var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST, getWeightDiscrepancyAggregateFailure, getWeightDiscrepancyAggregateSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const getWeightDiscrepancyAggregate = (action) => __awaiter(void 0, void 0, void 0, function* () {
    //   const { startTimestamp, endTimestamp } = action.payload;
    const startTimestamp = encodeURIComponent(action.payload.startTimestamp);
    const endTimestamp = encodeURIComponent(action.payload.endTimestamp);
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/report/weight/dispute/aggregate?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getWeightDiscrepancyAggregateWorker(action) {
    try {
        const data = yield call(getWeightDiscrepancyAggregate, action);
        yield put(getWeightDiscrepancyAggregateSuccess(data));
    }
    catch (error) {
        yield put(getWeightDiscrepancyAggregateFailure(error));
    }
}
export function* watchGetWeightDiscrepancyAggregateData() {
    yield takeLatest(GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST, getWeightDiscrepancyAggregateWorker);
}
